import { DoNotDisturb, Save } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { Control, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import GaiaHookFormSubmitButton from "~/modules/app/components/GaiaHookFormSubmitButton";

type Props<T extends FieldValues = FieldValues> = {
    control: Control<T>;
    onCancel: () => void;
};

export default function EcologicalFunctionActionsBox<T extends FieldValues = FieldValues>({ control, onCancel }: Props<T>) {
    const { t } = useTranslation("mapEditor");

    return (
        <Stack
            direction="row"
            p={2}
            gap={1}
            justifyContent="space-between"
            alignItems="center"
            sx={theme => ({ borderTop: `1px solid ${theme.palette.divider}` })}
        >
            <Button size="small" color="inherit" startIcon={<DoNotDisturb />} onClick={onCancel}>
                {t("featureDetailObservation.btnCancel")}
            </Button>
            <GaiaHookFormSubmitButton control={control} startIcon={<Save />} fullWidth={false}>
                {t("featureDetailObservation.btnSave")}
            </GaiaHookFormSubmitButton>
        </Stack>
    );
}
